import PropTypes from 'prop-types';
import React from 'react'
import createReactClass from 'create-react-class';
import { Link, browserHistory } from 'react-router-dom'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { findWhere, filter } from 'underscore'
import TimerMixin from 'react-timer-mixin';

import { seenNotification, getNewNotifications } from '~/actions/notifications'
import { Icon } from '~/components'
import { Item } from './components'


const Notifications = createReactClass({

	propTypes: {
		notifications: PropTypes.array,
		history: PropTypes.object
	},

	mixins: [TimerMixin],

	getInitialState: function() {
		return {
			notificationLimit: 10,
			unread: 0
		}
	},

	componentDidMount: function() {
		this.setInterval(
			() => { 
				if(this.props.notifications.length) this.props.getNewNotifications( this.props.notifications[0].ID )
			},
			10000
		);
	},

	getIcon: function(notifications) {
		let successIcon = <Icon icon="notifications" className='text-light-danger' />,
			falseIcon = <Icon icon="notificationsEmpty" className="text-white" />;
		return !!findWhere(notifications, {seen: false}) ? successIcon : falseIcon;
	},

	decreaseNotificationLimit: function() {
		this.setState({
			notificationLimit: 10
		})
	},

	increaseNotificationLimit: function() {
		this.setState({
			notificationLimit: this.state.notificationLimit += 10
		})
	},

	render: function() {

		var notifications = this.props.notifications && this.props.notifications.length > 0 ? this.props.notifications.slice(0) : [],
			icon = this.getIcon(notifications);

		return (
			
				<li className="menu-item dropdown nav-right">

					<a href="#" className="dropdown-toggle notification-icon" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
						{ icon }
					</a>

					<ul className="dropdown-menu notification-menu p0">

			        	{ !!notifications.length && this.state.notificationLimit > 10 &&
			        		<li>
			        			<a href="javascript:void(0);" className="pull-right" onClick={this.decreaseNotificationLimit}>See Less</a>
			        		</li>
		        		}

						{ !!notifications.length && notifications.map(notif => {
				            return <Item key={notif.ID} {...notif} />
				        }) }
				        
			        	{ notifications.length > this.state.notificationLimit &&
			        		<li>
			        			<a href="javascript:void(0);" className="pull-right" onClick={this.increaseNotificationLimit}>See more</a>
			        		</li>
			        	}

			        	{ !notifications.length && 
			        		<li><a href="javascript:void(0);">You have no notifications</a></li>
			        	}

					</ul>
				</li>
			
		)
	},

    componentWillUnmount: function(){
        this.clearInterval();
    }
	
})

const mapStateToProps = state => ({
    notifications: state.notifications.stored,
});

const mapDispatchToProps = dispatch => bindActionCreators({ getNewNotifications }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Notifications);



// WEBPACK FOOTER //
// ./src/js/components/Notifications/index.js